import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
//import ProgressBar from 'react-bootstrap/ProgressBar';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import ReactTable from 'react-table-6';
class OutReachCampaign extends Component {

  constructor() {
    super();
    this.state = {
      buttonDisabled: false,
      hideChoseFile: false,
      template: ''
    }

  }
  componentDidMount() {
    var settingController = this;

    setTimeout(() => {
      settingController.fetchTemplate();
      //settingController.fetchTeam();
    }, 300);

    document.addEventListener("projectChanged", function (event) {
      settingController.projectId = event.projectId;
      settingController.fetchTemplate(event.projectId);
    });
  }

  fetchTeam = () => {

    var manageController = this;
    $.ajax({
      url: "/salesdesk-api/fetch-team-members",
      async: false,
      method: 'GET',
      data: {
        projectId: localStorage.getItem('currentProjectId')
      },
      headers: {

        'Authorization': "Bearer " + localStorage.getItem("access_token")
      },
      success: function (res) {
        if (res.success === true) {
          manageController.notifySuccessToast();
        } else {
          manageController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      }
    });
  }

  downloadConversation = () => {
    var downloadController = this;

    $.ajax({
      url: "/salesdesk-api/download-sample-xls",
      async: false,
      method: 'GET',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token"), },
      success: function (res) {
        if (res.success === true) {
          const b64Data = res.result.data;
          const blob = downloadController.b64toBlob(b64Data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8', 512)
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = res.result.fileName;
          document.body.appendChild(link);
          link.click();
        } else {
          downloadController.notifyError("Oops! Error occurred. Please try again later");
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      }

    });
  }
  b64toBlob = (b64Data, contentType, sliceSize) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  componentWillUnmount() {
    clearTimeout(window.importStatusTimeoutHandle);
    clearTimeout(window.exportStatusTimeoutHandle);
  }
  noConfiguration = (e) => {

    toast(<b style={{ color: "red" }}>
      Oops! the configuration has not been done</b>, {
      position: "top-center",
      color: "red"

    });
  }
  notifyWarning(message) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
        &nbsp;&nbsp;{message}</b>, {
        position: "top-center"
    });
  }
  notifyError(falseRes) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseRes}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  notifySuccessToast(response) {
    toast.dismiss();
    toast(<b>
      <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;{response}</b>, {
      position: "top-center"
    });
  }

  startCampaign = () => {

    var userDetails = JSON.parse(localStorage.getItem("user_details"));
    if ($('#loadTemplate').val() == undefined) {
      this.notifyWarning("Please select Xls");

    }
    else if ($('#uploadXlsId')[0].files == undefined) {
      this.notifyWarning("Please select Xls");

    } else if ($('#uploadXlsId')[0].files[0].size >= 52428800) {
      this.notifyWarning("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.faqAsXlsxButtonDiable = true;
      this.setState(this.state);
    } else {
      this.notifySuccessToast("Upload Initiated...");

      var selectedTemplate = $('#loadTemplate').val();
      var importExportController = this;
      var formData = new FormData();
      formData.append("projectId", localStorage.getItem("currentProjectId"));
      formData.append("templateName", selectedTemplate);
      formData.append("emailId", userDetails.emailId);
      formData.append('campaignXlsxFile', $('#uploadXlsId')[0].files[0]);
      var uploadFaqAsXlsxTimer = setInterval(function () {
        clearTimeout(uploadFaqAsXlsxTimer);

        $.ajax({
          url: '/salesdesk-api/upload-campaign-xlsx',
          type: 'POST',
          headers: {
            'Authorization': "Bearer " + localStorage.getItem("access_token"),
          },
          data: formData,
          processData: false,
          contentType: false,
          success: function (data) {
            if (data.success === true) {
              importExportController.notifySuccessToast("Campaign Leads Xlsx Uploaded successfully!");
            } else {
              importExportController.notifyError("Oops!something went wrong while uploading Xls");
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "/platform/";
            }
          }
        });
      }, 2000);
    }

  }

  fetchTemplate = () => {

    var manageController = this;
    $.ajax({
      url: "/salesdesk-api/whatsapp/templates",
      async: false,
      method: 'GET',
      data: {
        projectId: localStorage.getItem('currentProjectId')
      },
      headers: {

        'Authorization': "Bearer " + localStorage.getItem("access_token")
      },
      success: function (res) {
        if (res.success === true) {
          var template = res.result;

          manageController.setState({ template: template });
          var numberOfTemplate = template.length;
          var ele3 = document.getElementById("loadTemplate");
          if (ele3 != "") {
            if (ele3 != null) {
              ele3.innerHTML = "";

              for (var i = 0; i < numberOfTemplate; i++) {
                if (template[i].approved != false) {
                  ele3.innerHTML = ele3.innerHTML + '<option value="' + template[i]['name'] + '">' + template[i]['name'] + '</option>';
                }
              }
            }
          }
        } else {
          manageController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      }
    });
  }
  handleChangeForTemplate = (event) => {
    // this.setState({
    //   value: event.target.value,
    //   template: document.getElementById('loadTemplate').value
    // });
    this.state.value = event.target.value;
    this.setState(this.state);
    this.fetchTemplate();
  }
  handleFile = (e) => {
    $('#uploadXlsId')[0].files = e.target.files;
    console.log("the $('#uploadXlsId')[0].files[0] is:" + $('#uploadXlsId')[0].files[0])
  }
  render() {

    return (
      <div id="tabPage" style={{ height: '35vw' }}>
        <div className="content" style={{ backgroundColor: "#F9F9FB", marginLeft: '-10px' }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <ToastContainer className="Toast-at-center" />
          <div className='row'>
            <div className="col-sm-3" >
              <h6 className="taglineTxt" style={{ marginLeft: '10%' }}>Select Template</h6>

              <select id="loadTemplate" value={this.state.value}
                onChange={this.handleChangeForTemplate}
                style={{
                  width: '90%', height: '30px', borderRadius: '4px',
                  backgroundColor: '#F9F9FB', marginLeft: '10%'
                }} ></select>
            </div>


            <div className="col-sm-2" style={{ marginLeft: "1vw" }}>
              <h6 className='taglineTxt'>Upload Xlsx</h6>
              <input type="file" id="audio-archive"
                ccept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv"
                onChange={this.handleFile}
                title="Choose Xls file"
                style={{
                  color: "black", marginTop: "10px", width: '90%'
                }} />
            </div>


            <div className='col-sm-2'>
              <button class="btn navyblue-btn " id="uploadXlsId"
                title="Start Campaign" style={{
                  marginTop: "25px", width: "150px"
                }}
                disabled={this.state.buttonDisable}
                onClick={e => this.startCampaign(e)}>
                Start Campaign
              </button>
            </div>

            <div className='col-sm-2'>
              <button className="btn2 table-action-button "
                title="Download sample xls"
                style={{ marginTop: '25px', height: "40px", marginLeft: "-3vw" }}
                onClick={() => {
                  this.downloadConversation();
                }}
              >Download Sample XLS</button>
            </div>
          </div>

        </div>
      </div>

    );
  }
}
export default OutReachCampaign;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/OutreachCampaign.js